import styled from 'styled-components'

import { Color } from 'root-constants'

export const QUESTION_PAGE_TOP_PADDING_VAR = '--question-page-top-padding'

export const StyledQuestionPage = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 375px;

    padding: var(${QUESTION_PAGE_TOP_PADDING_VAR}, 36px) 24px 0;
    margin: 0 auto;
  `,
  Title: styled.h1`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    padding-bottom: 24px;
  `,
}
